// The following polyfills are needed for IE11
import 'core-js/es/number/is-integer';
import 'core-js/es/number/is-nan';
import 'core-js/es/number/parse-float';
import 'core-js/es/number/parse-int';
import 'core-js/es/object/assign';
import 'core-js/es/object/set-prototype-of';
import 'core-js/es/promise';
import 'core-js/es/string/includes';
import 'core-js/es/string/starts-with';
import 'url-polyfill';

/**
 * This is our main. Here we re-export everything that needs to be publicly available.
 * The build enforces that the file has the same name as the global variable that is exported.
 *
 * The bootstrap pattern is the same for both desktop and server:
 * 1. External client calls createApiDispatcher|createApiDispatcherDesktop
 *    desktop: createApiDispatcherDesktop is called from bootstrap script in parent of the extension frame
 *             PresentationLayer is created in initializeWebChannelPresLayer
 *             @see ExtensionBrowserWidget.cpp in tableau
 *    server:  createApiDispatcher is called from ExtensionZoneView.cs in vizclient.
 *             PresentationLayer defaults to the global PluginPresentationLayer.Instance
 *             @see ApiDispatcher.ts
 * 2. ApiDispatcher.setExtensionFrame is called to establish parent iframe for postMessage handling
 *    desktop: called from createApiDispatcherDesktop (in Main.ts)
 *    server:  called from ExtensionZoneView.cs
 */

export { createApiDispatcherDesktop } from './desktop-bootstrap/Main';
export { createApiDispatcher, createEmbeddingApiDispatcher } from './server-bootstrap/Main';
